<template>
  <transition name="msgbox">
    <div v-if="previewData.visible"
         class="preview-container"
         @click.stop="endPreview">
      <div class="preview-main">

        <div class="preview-content"
             @click.stop="preventClickStrike">
          <span class="close-btn"
                @click.stop="endPreview">x</span>
          <video ref="video"
                 class="content-item"
                 autoplay
                 controls
                 v-if="obj.type === '1'"
                 :src="obj.src"></video>
          <div class="content-item"
               v-if="obj.type === '2'">
            <img class="item-img"
                 :src="obj.src"
                 alt="">
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script type="text/ecmascript-6">
export default {
  props: ["previewData"],
  data () {
    return {
      obj: {}
    };
  },
  created () {
    this.obj = this.previewData;
  },
  methods: {
    endPreview () {
      this.obj.visible = !this.previewData.visible;
      // this.$refs.video.pause();
      this.$emit("previewVisible", this.obj);
    },
    preventClickStrike () {
      console.log("阻止点击穿透行为");
    }
  },
  components: {}
};
</script>

<style lang="stylus" scoped>
.preview-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  z-index: 2000;

  .preview-main {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    position: relative;

    .preview-content {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      border-radius: 5px;

      .content-item {
        width: 100%;
        height: 100%;
        border: none;
        text-align: center;
        vertical-align: middle;
      }

      .close-btn {
        position: absolute;
        top: 0;
        z-index: 9999;
        border: 1px solid #ccc;
        border-radius: 50%;
        color: #fff;
        text-align: center;
        cursor: pointer;
        vertical-align: top;
      }
    }
  }
}

.msgbox-enter, .msgbox-leave-to {
  transform: translate(0, 0) scale(0, 0);
}

.msgbox-enter-active, .msgbox-leave-active {
  transition: all 0.2s;
}

.msgbox-enter-to, .msgbox-leave {
  transform: translate(0, 0) scale(1, 1);
}

@media all and (min-width: 1601px) {
  .preview-content {
    width: 1280px;
    height: 720px;

    .close-btn {
      right: -80px;
      width: 50px;
      height: 50px;
      font-size: 36px;
      line-height: 45px;
    }
  }
}

@media all and (min-width: 1400px) and (max-width: 1600px) {
  .preview-content {
    width: 1080px;
    height: 608px;

    .close-btn {
      right: -80px;
      width: 50px;
      height: 50px;
      font-size: 36px;
      line-height: 45px;
    }
  }
}

@media all and (min-width: 769px) and (max-width: 1399px) {
  .preview-content {
    width: 800px;
    height: 450px;

    .close-btn {
      right: -60px;
      width: 40px;
      height: 40px;
      font-size: 34px;
      line-height: 35px;
    }
  }
}

@media all and (max-width: 768px) {
  .preview-content {
    width: 100%;
    max-width: 600px;
    max-height: 340px;

    .close-btn {
      right: 20px;
      top: 50px;
      width: 40px;
      height: 40px;
      font-size: 34px;
      line-height: 35px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/preview/index.vue